import { IField } from "../interfaces/inputs/IField";

export const SaleUpdateFields: IField[] = [
  { name: "date", type: "date", label: "Date", size: {lg: 12}, position: 1 },
  { name: "remark", type: "textarea", label: "Details", rows: 6, size: {lg: 12}, position: 5 },
].sort((a: IField, b: IField) => a.position - b.position);